import { notification } from 'antd'

type NotificationType = 'success' | 'info' | 'warning' | 'error'

export const showNotification = (type: NotificationType, message: string, description: string = null) => {
  notification[type]({
    message,
    description,
    placement: 'bottomRight',
    style: { borderRadius: '10px' }
  })
}
